import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import { getAuth, patchAuth, postAuth, deleteAuth } from 'api/Utils';


export function postControlSuspendOrganization(successCallback, errorCallback, data, organizationId) {
  postAuth({
    "path": `control/organizations/${organizationId}/suspend`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function postControlUnsuspendOrganization(successCallback, errorCallback, organizationId) {
  postAuth({
    "path": `control/organizations/${organizationId}/unsuspend`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function postControlUpdateSendingEligibility(successCallback, errorCallback, data, organizationId) {
  postAuth({
    "path": `control/organizations/${organizationId}/update-sending-eligibility`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function postControlUpdateReviewRequestEligibility(successCallback, errorCallback, data, organizationId) {
  postAuth({
    "path": `control/organizations/${organizationId}/update-review-request-eligibility`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function postControlUpdateNumAccountsLimit(successCallback, errorCallback, data, organizationId) {
  postAuth({
    "path": `control/organizations/${organizationId}/update-num-accounts-limit`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function postControlUpdateAppliedCoupon(successCallback, errorCallback, data, organizationId) {
  postAuth({
    "path": `control/organizations/${organizationId}/update-applied-coupon`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteControlOrganizations(successCallback, errorCallback, organizationId) {
  deleteAuth({
    "path": `control/organizations/${organizationId}`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
  });
}
